const ru = {
	"catalog-title": "Общие материалы",
	"group-fragments": "Фрагменты",
	"group-templates": "Шаблоны",
	"scope-title": "общих материалах",
	"fragment-loading": "Фрагмент появится, когда загрузятся общие материалы",
	"fragment-failed": "Фрагмент {{id}} не показан: общие материалы не загрузились",
	"reserved-name": "Это имя занято общими материалами",
	"error-mismatch": "В папке общих материалов лежит другой репозиторий",
	"error-empty": "В репозитории общих материалов нет ветки master",
	"error-no-access":
		"Репозиторий общих материалов не найден или недоступен вам. Обратитесь к администратору пространства.",
	"error-unreadable": "Не удалось прочитать опубликованные общие материалы",
	"error-broken": "Репозиторий общих материалов, возможно, поврежден. Загрузите его заново.",
	"error-no-server-source": "Не задан адрес Gramax Enterprise Server, из которого загружаются общие материалы",
};

export type WorkspaceToolsKey = keyof typeof ru;

export default ru;
